import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent {
  title = 'PayKanz';
  titleObj:any = {};
  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
 //  this.titleObj =  this.route.snapshot.firstChild.data;
  }


}
